var React = require('react');

function GraphUp48px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47 31.999H1a1 1 0 0 1-1-1V.998a.999.999 0 1 1 2 0v29.001h45a1 1 0 1 1 0 2zm-6-20a1 1 0 0 1-1-1V7.292L27.681 18.731c-.006.006-.014.007-.02.013-.004.004-.006.009-.011.013-.054.047-.117.072-.178.105-.042.023-.079.056-.123.072a.98.98 0 0 1-.751-.021c-.041-.019-.073-.055-.112-.079-.076-.047-.155-.086-.218-.155-.005-.005-.006-.012-.011-.018-.005-.005-.011-.006-.016-.011l-5.364-6.259-10.244 8.382a1 1 0 1 1-1.266-1.548l11-9c.052-.042.113-.059.17-.089.057-.031.11-.072.171-.091.065-.02.132-.017.2-.023.06-.006.12-.022.18-.017.066.006.127.034.191.053.059.017.12.024.176.052.068.035.123.093.183.144.039.033.086.054.121.094l.011.014.004.003.002.004 5.306 6.189 11.372-10.56H35a.999.999 0 1 1 0-1.999h6l.018.003c.081.002.157.027.235.048.049.013.101.014.146.034.046.02.083.058.127.085.067.043.137.081.192.138.004.004.01.006.014.011.034.036.048.082.075.122.044.063.091.123.12.195.027.07.032.143.043.216.008.05.03.095.03.148v6a1 1 0 0 1-1 1z","key":1})]);
}

GraphUp48px.displayName = "GraphUp48px";

GraphUp48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 32"};

module.exports = GraphUp48px;

GraphUp48px.default = GraphUp48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/graph-up-48px.svg
// module id = 1140
// module chunks = 0